import config from '@/config'
import http from '@/utils/request'

const base = `${config.API_URL}/manage/codeGeneration`

export default {
	list: { url: `${base}/list`, get: async (params = {}) => await http.get(`${base}/list`, params) },
	options: { url: `${base}/options`, get: async () => await http.get(`${base}/options`) },
	inspect: { url: `${base}/inspect`, get: async (params = {}) => await http.get(`${base}/inspect`, params) },
	detail: { url: `${base}/detail`, get: async (params = {}) => await http.get(`${base}/detail`, params) },
	save: { url: `${base}/save`, post: async (data = {}) => await http.post(`${base}/save`, data) },
	preview: { url: `${base}/preview`, post: async (data = {}) => await http.post(`${base}/preview`, data) },
	remove: { url: `${base}/delete`, delete: async (data = {}) => await http.delete(`${base}/delete`, data) },
	files: { url: `${base}/files`, get: async (params = {}) => await http.get(`${base}/files`, params) },
	file: { url: `${base}/file`, get: async (params = {}) => await http.get(`${base}/file`, params), post: async (data = {}) => await http.post(`${base}/file`, data) },
	download: { url: `${base}/download`, get: async (params = {}, requestConfig = {}) => await http.get(`${base}/download`, params, requestConfig) },
	logs: { url: `${base}/logs`, get: async (params = {}) => await http.get(`${base}/logs`, params) },
	association: { url: `${base}/association`, get: async (params = {}) => await http.get(`${base}/association`, params) },
	dictionary: {
		list: async () => await http.get(`${base}/dictionary/list`),
		detail: async (params = {}) => await http.get(`${base}/dictionary/detail`, params),
		save: async (data = {}) => await http.post(`${base}/dictionary/save`, data),
		remove: async (data = {}) => await http.post(`${base}/dictionary/delete`, data)
	},
	build: { url: `${base}/build/stream`, get: async (params = {}) => await http.get(`${base}/build/stream`, params) }
}
